// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1N5fN","name":"styles_name__2gDn_","phone":"styles_phone__3PPIV"};